<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="viewKey" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" :key="viewKey" />
  </div>
</template>

<script>
// import { login } from "./api/platform";
export default {
  name: "app",
  data () {
    return {
      token: "",
    };
  },
  created () {
  },
  computed: {
    viewKey () {
      // 每次都根据 key 判断是否刷新组件
      return this.$route.meta._pageKey || this.$route.fullPath
    }
  },
  methods: {
  },
};
</script>
<style scoped>
.router-fade-enter-active,
.router-fade-leave-active {
  transition: opacity 0.3s;
}
.router-fade-enter,
.router-fade-leave-active {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue